import Logic from "../../awrabet/utils/ticket-logic";
export * from "../../awrabet/utils/ticket-logic";
export default Logic;